import apiFetch from 'api/base'
import { AxiosPromise } from 'axios'

const URL = `/demo-auth/register`

const demoAuthRegister = (data: {
  visitorId: string
  preferredCurrency: number
  clickId?: string | null
  offer?: string | null
  partnerId?: string | null
  registrationSourceId: number | string | null
  sessionId?: string | null
}): AxiosPromise => apiFetch(URL, { method: `POST`, data })

export default demoAuthRegister
